import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { MapComponent } from "./components/MapComponent";
import { SettingComponent } from "./components/SettingComponent";
import { PageSettingComponent } from "./components/PageSettingComponent";
import { MiniGameComponent } from "./components/MiniGameComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-inventory", InventoryComponent);
window.customElements.define("room-map", MapComponent);
window.customElements.define("game-settings", SettingComponent);
window.customElements.define("game-page-settings", PageSettingComponent);
window.customElements.define("mini-game", MiniGameComponent);
